import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import MuiDialog from "@material-ui/core/Dialog";
import { Fab, CircularProgress } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";
import omit from "omit";

const CloseButton = styled(Fab)`
  background-color: #ec0000;
  color: #fff;
  right: ${({ $right }) => $right};
  top: ${({ $top }) => $top};
  position: absolute;
  z-index: 10;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.22);
  :hover {
    background-color: #bc0000;
  }
`;

const Progress = styled(CircularProgress)`
  position: absolute;
  bottom: 34px;
  right: 24px;
`;

const Dialog = props => {
  const { t } = useTranslation();
  const { children, onClose, closeButton, loading, closeButtonPosition } = props;
  return (
    <MuiDialog
      {...omit(["closeButton", "loading", "closeButtonPosition"], props)}
    >
      {closeButton && (
        <CloseButton
          onClick={onClose}
          size="medium"
          disabled={loading}
          aria-label={t("ui.dialog.close")}
          $top={closeButtonPosition.top}
          $right={closeButtonPosition.right}
        >
          <CloseIcon />
        </CloseButton>
      )}
      {children}
      {loading && <Progress size={34} />}
    </MuiDialog>
  );
};

Dialog.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  closeButton: PropTypes.bool,
  loading: PropTypes.bool,
  closeButtonPosition: PropTypes.shape({
    top: PropTypes.string,
    right: PropTypes.string
  })
};

Dialog.defaultProps = {
  closeButton: false,
  loading: false,
  closeButtonPosition: {
    top: "12px",
    right: "12px"
  }
};

export default Dialog;
